import { compact, upperFirst } from 'lodash'

export const formatName = ({
  firstName,
  lastName,
}: {
  firstName?: string | null
  lastName?: string | null
} = {}) => compact([firstName?.trim(), lastName?.trim()]).join(' ')

export const humanize = (stringToTransform = '', isSentenced = false) => {
  const humanizedString = stringToTransform
    ?.toString()
    .toLowerCase()
    .replace(/\.|_/g, ' ')
    .split(' ')
    .slice(0)
    .map(l => l.slice(0, 1).toUpperCase() + l.slice(1))
    .join(' ')
    .trim()

  return isSentenced
    ? upperFirst(humanizedString.replace(/-/g, ' ').toLowerCase())
    : humanizedString
}
